import z from "zod";
import {zodRequiredStringSchema} from "./zodRequiredStringSchema";
import {zodRequiredNumberInputSchema} from "./zodRequiredNumberInputSchema";

export const zodRequiredPriceSchema = z
    .object({
        currency: zodRequiredStringSchema,
        value: zodRequiredNumberInputSchema,
    })
    .superRefine((val, ctx) => {
        if (val?.value < 0) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                path: ['value'],
                message: 'Please add a number',
            });
        }
    });
